import { connect } from 'react-redux'

export default function withPortal(WrappedComponent) {
  return connect(({ portal }) => ({ portal }))(WrappedComponent)
}



// WEBPACK FOOTER //
// ./src/modules/portal-redux/withPortal.js